import { Box } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { ReportComment } from "../ReportComment";
import { getClubReviewsInfo, getCriteriaComments, getCriteriaCommentsHistory, getOnSiteCriteria, getOnSiteCriteriaComments, getPhaseProgress, getSelfAssessmentCriteria, saveCriteriaComments, updateOnSiteCriteriaComments } from "../../api/evaluation";
import { useDispatch, useSelector } from "react-redux";
import { resetCriteriaComment, setCommentContent, setCriteriaComment, setCriteriaCommentsHistory, setOnSiteCriteriaComments, setSaCriteria, setSelectedCommentBoxTab } from "../../redux/reducers/evaluation";
import { difference } from "lodash";
import { useTranslation } from "react-i18next";
import { setSnackBarData } from "../../redux/reducers/common";

const EvaluationCommentBoxWrapper = (props:any) => {
    
    const dispatch = useDispatch();
    const clubDetails = useSelector((state:any) => state.clubDetails);
    const currentSection = useSelector((state:any) => state.evaluation.currentEvaluationTab);
    const currentCriteria = useSelector((state:any) => state.evaluation.selectedSaCriteria);
    const onSiteCriteriaComments = useSelector((state:any) => state.evaluation.onSiteCriteriaComments);
    const criteriaComments = useSelector((state:any) => state.evaluation.criteriaComment);
    const commentContent = useSelector((state:any) => state.evaluation.commentContent);
    const criteriaCommentsHistory = useSelector((state:any) => state.evaluation.criteriaCommentsHistory);
    const [isEdited, setIsEdited] = useState(false);
    const isAdmin = useSelector((state:any) => state.common.isAdmin);
    const [t] = useTranslation();
    const selectedTab:any = useSelector((state:any) => state.evaluation.selectedCommentBoxTab);
    const [progressData, setProgressData] = useState<any>({});
    const onSiteCriteria = useSelector(
    (state: any) => state.evaluation.onSiteCriteria
    );
    const initialOnSiteCommentObj = {
        "id": null,
        "comment": "",
        "criteriaId": currentCriteria?.id,
        "clubId": clubDetails?.id,
        "userAvatarPath": null,
        "updatedUserFirstName": null,
        "updatedUserLastName": null,
        "updatedDate": null,
        "sessionId": null
    }
    
    const fetchOnSiteComments = async () => {
        const reviewData = await getClubReviewsInfo({clubId: clubDetails.id});
        if(reviewData && reviewData.onSiteReviewId){
            const sessions = !onSiteCriteria ? await getOnSiteCriteria({onSiteReviewId: reviewData.onSiteReviewId, criteriaId: currentCriteria.id}) : onSiteCriteria;
            // dispatch(setOnSiteCriteria(sessions));
            const response = await getOnSiteCriteriaComments({clubId: clubDetails?.id, criteriaId: currentCriteria?.id});
            const sessionIds = sessions.map((d:any) => d.id);
            const commentedSessionIds = response.map((d:any) => d.sessionId) ;
            const idsToAddNew = difference(sessionIds, commentedSessionIds);
            const listToAdd = idsToAddNew?.map((d:any) => {return {...initialOnSiteCommentObj, sessionId: d}});
            const updatedList  =[...response, ...listToAdd];
            return updatedList;
        }
    };
    const fetchCriteriaComments = async () => {
        const response = await getCriteriaComments({ clubId: clubDetails.id, criteriaId: currentCriteria.id});
        return response;
    }
    const fetchCriteriaCommentsHistory = () => {
        getCriteriaCommentsHistory({ clubId: clubDetails.id, criteriaId: currentCriteria.id})
        .then((historyRes:any) => {
            dispatch(setCriteriaCommentsHistory(historyRes));
        })
    }
    useEffect(() => {
        if (currentCriteria && currentCriteria.id && clubDetails && clubDetails.id) {
            fetchOnSiteComments().then((res:any) => {
                dispatch(setOnSiteCriteriaComments(res));
            }); 
            fetchCriteriaComments().then((res:any) => {
                if(res != null) {
                    dispatch(setCriteriaComment(res || Object));
                } else {
                    dispatch(resetCriteriaComment());
                }
                fetchCriteriaCommentsHistory();
            })
            getPhaseProgress({clubId: clubDetails.id, criteriaId: currentCriteria.id}).then((res:any) => {
                setProgressData(res || {});
            });
        }
    }, [currentCriteria]);

    useEffect(() => {
         (!currentCriteria || Object.keys(currentCriteria)?.length == 0) && dispatch(resetCriteriaComment());
    }, [currentSection]);

    const fetchKey:any = (value:any) => {
        switch(value) {
            case t('SELF_ASSESSMENT'):
            case 'SELF_ASSESSMENT':
                return 'selfAssessmentComment';
            case t('OFF_SITE'):
            case 'OFF_SITE':
                return 'offSiteComment';
            case t('ON_SITE'):
            case 'ON_SITE':
                return 'comment';
            // case t('INTERIM_REPORT'):
            // case 'INTERIM_REPORT':
            //     return 'interimReportComment';
            case t('REPORTS'):
            case 'REPORTS':
                return 'finalReportComment';
        }
    }

    const fetchCommentHistory:any = (value:any) => {
        switch(value) {
            case t('SELF_ASSESSMENT'):
            case 'SELF_ASSESSMENT':
                return criteriaCommentsHistory?.selfAssessmentCommentHistory || [];
            case t('OFF_SITE'):
            case 'OFF_SITE':
                return criteriaCommentsHistory?.offSiteCommentHistory || [];
            case t('REPORTS'):
            case 'REPORTS':
                return criteriaCommentsHistory?.reportsCommentHistory || [];
        }
    }
    
    const manageChange = (value:any, currentOnsiteData:any) => {
        if (selectedTab == t('ON_SITE')) {
            const tempArr:any = onSiteCriteriaComments.map((x:any) => {
                if (x.sessionId == currentOnsiteData.sessionId) {
                    return { ...x, comment: value }
                } return x;
            });
            dispatch(setOnSiteCriteriaComments(tempArr));
        } else {
            dispatch(setCriteriaComment({...criteriaComments, [fetchKey(selectedTab)]: value}));
        }
        setIsEdited(true);
    }

    const manageSaveComment = async (currentOnsiteData:any) => {
        if (isEdited) {
            if(selectedTab == t('ON_SITE')) {
                const response = await updateOnSiteCriteriaComments({data: currentOnsiteData});
                // const tempArr:any = [...onSiteCriteriaComments, ...response];
                dispatch(setOnSiteCriteriaComments(response));
            } else {
                saveCriteriaComments({id: criteriaComments?.id ? criteriaComments.id : 0,
                        data: {...criteriaComments,
                        criteriaId: currentCriteria?.id, clubId: clubDetails.id,
                        }}).then((res:any) => {
                        dispatch(setCriteriaComment(res || Object));
                        fetchCriteriaCommentsHistory();
                        });
            }   
        }
        updateCriteriaMetadata();
    }

    const manageDeleteComment = async (commentOf:any, commentData:any) => {
        if (commentOf == t('ON_SITE')) {
            // const tempArr:any = onSiteCriteriaComments.map((x:any) => {
            //     if (x.sessionId == commentContent?.sessionId) {
            //         return { ...x, comment: '', commentUpdatedUsers: commentContent?.commentUpdatedUsers.length > 0 ? commentContent?.commentUpdatedUsers : []  }
            //     } return {...x, commentUpdatedUsers: commentContent?.commentUpdatedUsers.length > 0 ? commentContent?.commentUpdatedUsers : [] };
            // });
            const contentToDelete = {...commentData, comment: ''};
            await updateOnSiteCriteriaComments({data: contentToDelete}).then((res:any) => {
                dispatch(setOnSiteCriteriaComments(res));
                const warningData:any = {isOpen: true, severity: 'success', message: t('UPDATED_CRITERIA_COMMENT_SUCCESSFULLY')};
                dispatch(setSnackBarData(warningData));
            });
        } else {
            const updatedComments = {...criteriaComments, [fetchKey(commentOf)]: ''};
            saveCriteriaComments({id: criteriaComments?.id ? criteriaComments.id : 0,
                    data: {...updatedComments,
                    criteriaId: criteriaComments?.id, clubId: clubDetails.id,
                    }}).then((res:any) => {
                        dispatch(setCriteriaComment(updatedComments));
                        const warningData:any = {isOpen: true, severity: 'success', message: t('UPDATED_CRITERIA_COMMENT_SUCCESSFULLY')};
                        dispatch(setSnackBarData(warningData));
                    });
        }
        updateCriteriaMetadata();
    }

    const updateCriteriaMetadata = () => {
        getSelfAssessmentCriteria({clubId: clubDetails.id}).then((res:any) => {
            dispatch(setSaCriteria(res));
        });
    }

    const manageTabSwitch = (newTab:any) => {
        dispatch(setSelectedCommentBoxTab(newTab));
    }

    useEffect(() => {
        if (selectedTab ==null || selectedTab == undefined) {
            const tempTab:any = isAdmin ? t('OFF_SITE') : t('SELF_ASSESSMENT');
            dispatch(setSelectedCommentBoxTab(tempTab));
        }
    }, [selectedTab]);

    return (
        <>
            {/* <Box sx={{ width: '30%' }}>
                <CommentsOverviewBox 
                parentComponent={'jlEval'}
                tabs={tabs}
                selectedTab={selectedTab}
                handleTabChange={handleTabChange}
                currentTab={currentSection}
                onSiteCriteriaComments={onSiteCriteriaComments}
                criteriaComments={criteriaComments}
                selectedCriteria={currentCriteria}
                selectedCommentPhase={selectedCommentPhase}
                deleteComment={manageDeleteComment} />
            </Box> */}
            <Box sx={{ width: '100%' }}>
                <ReportComment 
                manageChange={manageChange}
                manageSaveComment={manageSaveComment}
                tabList={isAdmin ? [t('SELF_ASSESSMENT'), t('OFF_SITE'), t('ON_SITE'), t('REPORTS')] : [t('SELF_ASSESSMENT'), t('REPORTS')]}
                selectedTab={selectedTab}
                deleteComment={manageDeleteComment}
                onSiteCriteriaComments={onSiteCriteriaComments}
                criteriaComments={criteriaComments}
                isDeletable={isAdmin && selectedTab == t('SELF_ASSESSMENT') ? false : true}
                handleTabSwitch={manageTabSwitch} 
                commentHistory={fetchCommentHistory(selectedTab)}
                progress={progressData} />
            </Box>
        </>
    )
}

export default EvaluationCommentBoxWrapper;